import { render, staticRenderFns } from "./MyCampaignsPage.vue?vue&type=template&id=27216546&scoped=true&"
import script from "./MyCampaignsPage.vue?vue&type=script&lang=js&"
export * from "./MyCampaignsPage.vue?vue&type=script&lang=js&"
import style0 from "./MyCampaignsPage.vue?vue&type=style&index=0&id=27216546&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27216546",
  null
  
)

export default component.exports